export const isHttpUrl = (url: string | null | undefined): boolean => {
  try {
    const parsedUrl = new URL(url || "");
    return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
  } catch {
    return false;
  }
};

export const externalLinkProps = (url: string | null | undefined) =>
  isHttpUrl(url)
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {};
